import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { routeAddress } from '../http/route_address';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LocalStorage } from '../localstorage';

export interface BaseResponse<T> {
    description: string;
    registers: T;
    status_code: number;
    token: string;
    tokenParameter: {
        currencySimbol: string;
        language: string;
        languageFile: string;
        policyReview: number;
        production: boolean;
        userSituation: string;
    };
}

/**
 * Classe abstrata reutilizável para todos os serviços
 */
export abstract class BaseService {
    public localStorage = new LocalStorage();
    /**
     * Constants: Definidas no arquivo de ambiênte environment
     */
    protected urlService: string = environment.urlApi;
    protected identifySystem: string = environment.identifySystem;

    /**
     * Recebe os endereços das apis a serem utilizadas
     */
    protected routeAdress = routeAddress;

    /**
     * getHeaderJson: Montar header para envio na API
     */
    protected getHeaderJson() {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'Cache-Control:no-cache',
            }),
        };
    }

    /**
     * body: inicializar valores iniciais para POST
     * Utilizado em todas as chamadas de API
     */
    public setBody(): any {
        let body = new URLSearchParams();

        // Token de identificação da entidade usuária do ADM
        let token = this.localStorage.getToken();
        let host = this.localStorage.getHost();
        let lang: any = this.localStorage.getUserLangs()?.selected;

        if (lang?.value) {
            body.set('language', lang?.value);
        } else if (lang) {
            body.set('language', lang);
        }

        // Identificação do host utilizado
        body.set('host', host);
        // Token de identificação
        body.set('token', token);
        // Identificação do tipo de sistema
        body.set('system', this.identifySystem);

        return body;
    }

    protected extractData(response: any) {
        return response || {};
    }

    protected serviceError(response: Response | any) {
        let customError: string[] = [];

        if (response instanceof HttpErrorResponse) {
            if (response.statusText === 'Unknown Error') {
                customError.push('ocorreu um erro desconhecido');
                response.error.errors = customError;
            }
        }

        console.error(response);
        return throwError(response);
    }

    /**
     * Adiciona todas as chaves e valores do objeto `param``
     * como parametro do body para requsição
     * @param body Instância do body
     * @param params Parametros
     */
    setParams<T = Record<string, string>>(body: URLSearchParams, params: T) {
        Object.keys(params).forEach((paramKey) => body.set(paramKey, params[paramKey]));
    }
}
